import React from 'react';

import styled from 'styled-components';

const Button = styled.button`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  text-align: left;
  cursor: pointer;

  &.with-chevron {
    flex-direction: row;
    align-items: center;
    gap: 8px;
    width: calc(100% + 16px);
    max-width: none;
    margin: -6px -8px;
    padding: 6px 8px;
    border-radius: 6px;
    transition: background-color 0.15s;

    &:hover {
      background: var(--faded-blue);
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
`;

type Props = {
  onClick: () => void;
  dataTestId?: string;
  withChevron?: boolean;
  children: React.ReactNode;
};

const ClickableCellValue = ({ onClick, dataTestId, withChevron, children }: Props) => (
  <Button
    type="button"
    onClick={onClick}
    data-test-id={dataTestId}
    className={withChevron ? 'with-chevron' : undefined}
  >
    {withChevron ? (
      <>
        <Content>{children}</Content>
        <img src="/icons/chevron-right.svg" width="16" height="16" alt="" />
      </>
    ) : (
      children
    )}
  </Button>
);

export default ClickableCellValue;
